import { apiUrl } from '$lib/settings/api';

/** @type {import('./$types').PageLoad} */
export async function load({ params }) {
	const url = apiUrl + 'events/events/index?limit=20';
	const res = await fetch(url);
	const apiResponse = await res.json();
	const events = apiResponse['data']['documents'];

	return {
		events: events
	};
}
